var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "12px",
    viewBox: "0 0 5 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "caret-right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "-5.28281108e-16 6.751689 2.9578828 3.858108 -5.28281108e-16 0.9002252 0.9002252 -2.92125175e-13 4.7583332 3.858108 0.9002252 7.716216"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PN-v1.5---2.0-Register---Add-Serial---Main",
    transform: "translate(-408.000000, -268.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sidebar-Nav",
    transform: "translate(106.000000, 245.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-color",
    transform: "translate(302.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#616A70",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "#0375BA",
    id: "Rectangle-6-Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.000000, -8.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 24 0 24 24 0 24"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRight);
export default __webpack_public_path__ + "static/media/caret-right.cfbcbca0ee77c84d64449b48c36ef936.svg";
export { ForwardRef as ReactComponent };